<template>
    <PageLayout id="Hos_Covt_Pending_container" :has-buttons="false" :has-title="false" content-class="p-0">
        <template #content>
            <template v-if="isLoadError || isFormLoading || isSaveInProgress">
                <section class="card w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                    <div class="d-flex flex-column align-items-start" v-if="isLoadError && !isFormLoading">
                        <h5 class="fw-bold">Error</h5>
                        <p class="font-size-xl mb-1">
                            <template v-if="patientId">
                                There was problem while loading the referral. Please try again.
                            </template>
                            <template v-else>
                                There was problem while generating the referral form. Please try again.
                            </template>
                        </p>
                        <span class="mb-2"> </span>
                        <button class="btn btn-primary" @click="getPatientDetails()">Try Again</button>
                    </div>
                    <template v-if="isFormLoading && !isLoadError">
                        <i class="fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2"></i>
                        <span class="font-size-xl">Loading Referral Form...</span>
                    </template>
                    <div v-if="isSaveInProgress" class="d-flex flex-column align-items-center">
                        <i class="far fa-save fa-7x text-primary animated flash infinite slow mb-2"></i>
                        <span class="font-size-xl text-center">Saving Referral...</span>
                    </div>
                </section>
            </template>
            <template v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
                <TabsLayout
                    :header="`Edit Hospice Patient-${formatName(patientDetails.firstName, patientDetails.lastName)}`"
                    :tabs="tabs"
                    :activeTab="activeTab"
                    :handleTabChange="handleTabChange"
                    :showErrors="() => false"
                    :showWarnings="() => false"
                    :showSuccess="() => false"
                >
                    <template #forms>
                        <section class="px-3 my-2">
                            <div v-show="activeTab === 1">
                                <Demographics />
                            </div>
                            <div v-show="activeTab === 2">
                                <PayerInformation />
                            </div>
                            <div v-show="activeTab === 3">
                                <ClinicalInformation />
                            </div>
                            <div v-show="activeTab === 4"><Physicians /></div>
                            <div v-show="activeTab === 5">
                                <PharmacyAndDME />
                            </div>
                            <div v-show="activeTab === 6">
                                <AuthorizedContact />
                            </div>
                            <div v-show="activeTab === 7">
                                <EmergencyPreparedness />
                            </div>
                            <div v-show="activeTab === 8">
                                <AdvanceDirectives />
                            </div>
                            <div v-show="activeTab === 9">
                                <ReferralInformation />
                            </div>
                        </section>
                    </template>
                    <template v-if="!isLoadError && !isFormLoading && !isSaveInProgress" #buttons>
                        <div class="d-flex justify-content-center mt-2 hos-button-container py-2">
                            <button
                                type="button"
                                class="btn btn-outline-primary me-2"
                                @click="handleCancelConvertToPending()"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary me-2"
                                v-if="activeTab !== 1"
                                @click="handlePrevious()"
                            >
                                Previous
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary me-2"
                                v-if="activeTab !== 9"
                                @click="handleNext()"
                            >
                                Next
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary me-2"
                                v-if="activeTab !== 9"
                                @click="handleSave()"
                            >
                                Save
                            </button>
                            <button type="button" class="btn btn-primary" v-if="activeTab === 9" @click="handleSave()">
                                Complete
                            </button>
                        </div>
                    </template>
                </TabsLayout>
            </template>
        </template>
    </PageLayout>
</template>

<style src="./HospiceConvertToPending.scss"></style>
<script src="./HospiceConvertToPending.ts"></script>
